import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinpune() {



  const cardData =
  {
    keyword: 'Bus Hire in Pune',
    heading: 'Amruta Travels: Bus Hire in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides convenient and affordable Bus Hire in Pune, offering a wide range of luxury and budget buses for all types of travel needs. Whether you’re planning a corporate trip, school excursion, family vacation, or wedding transport, our fleet includes well-maintained AC, Non-AC, and luxury coaches with comfortable push-back seats, air conditioning, and ample luggage space. Each journey is driven by professional chauffeurs ensuring safety, punctuality, and a smooth travel experience. With reliable service across Pune, Pimpri Chinchwad, and nearby destinations like Mahabaleshwar, Shirdi, and Mumbai, Amruta Travels’ Bus Hire in Pune is the perfect choice for groups seeking comfort, quality, and value in every ride.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Bus Hire in Pune",
      "description": "Bus Hire in Pune offers a versatile fleet of buses for local and outstation travel, catering to groups of all sizes. Whether for corporate outings, family trips, or social events, this service ensures well-maintained vehicles, professional drivers, and timely pickups. Emphasizing customer satisfaction, it provides flexible booking options and transparent pricing for hassle-free group transportation."
    },
    {
      "name": "Bus Rental Pune",
      "description": "Bus Rental Pune specializes in renting buses with varied capacities to meet diverse travel needs across Pune and its outskirts. Customers can choose from AC and non-AC options, luxury coaches, and mini buses for corporate events, school trips, and sightseeing tours. Each vehicle undergoes rigorous safety checks and is driven by experienced chauffeurs committed to providing a comfortable ride."
    },
    {
      "name": "AC Bus Hire Pune",
      "description": "AC Bus Hire Pune ensures a cool and pleasant journey with air-conditioned buses that are perfect for Pune’s warm weather. These buses are equipped with modern AC systems, plush seating, and ample luggage space. Ideal for long-distance travel, corporate trips, weddings, and tourist excursions, the service includes professional drivers focused on passenger comfort and safety throughout the trip."
    },
    {
      "name": "Non AC Bus Hire Pune",
      "description": "Non AC Bus Hire Pune offers economical and reliable transportation options without air conditioning, making it suitable for budget-conscious travelers and short city trips. These buses maintain high cleanliness and safety standards, ensuring a comfortable ride. Experienced drivers provide punctual and courteous service, making it a popular choice for schools, local tours, and group outings."
    },
    {
      "name": "Luxury Bus Hire Pune",
      "description": "Luxury Bus Hire Pune features premium buses with upscale interiors, advanced amenities like entertainment systems and Wi-Fi, and spacious seating designed for VIP travel. Perfect for weddings, corporate events, and high-profile tours, these buses provide an elegant and comfortable travel experience. Professional chauffeurs ensure a smooth ride with discreet and attentive service."
    },
    {
      "name": "Tourist Bus Hire Pune",
      "description": "Tourist Bus Hire Pune caters to travelers seeking convenient and comfortable transport for sightseeing and group excursions around Pune and nearby attractions. These buses offer spacious interiors, large luggage compartments, and knowledgeable drivers who often provide local insights. Customized travel itineraries enhance the overall tourist experience, making group travel both enjoyable and hassle-free."
    },
    {
      "name": "Mini Bus Hire Pune",
      "description": "Mini Bus Hire Pune specializes in compact buses ideal for smaller groups, local tours, and short trips within the city. These mini buses combine maneuverability with passenger comfort, offering sufficient seating and luggage space. Suitable for family outings, corporate day trips, and quick transfers, the service guarantees timely pickups and professional drivers who know Pune’s traffic well."
    },
    {
      "name": "Volvo Bus Hire Pune",
      "description": "Volvo Bus Hire Pune provides high-end Volvo buses renowned for their smooth rides, safety features, and superior comfort. These buses are perfect for long-distance travel, corporate tours, and luxury group outings. Equipped with modern amenities and driven by skilled chauffeurs, they ensure a premium travel experience with punctuality and reliability."
    },
    {
      "name": "Corporate Bus Hire Pune",
      "description": "Corporate Bus Hire Pune offers professional transportation solutions tailored to business needs, including employee commutes, client visits, and corporate events. The fleet comprises clean, well-maintained buses with modern facilities, driven by courteous and punctual chauffeurs. This service supports flexible rental terms to accommodate dynamic corporate schedules efficiently."
    },
    {
      "name": "Wedding Bus Hire Pune",
      "description": "Wedding Bus Hire Pune provides elegant and spacious buses designed to transport wedding guests comfortably and on time. Options for vehicle decoration and customized services ensure that the transportation complements the grandeur of the occasion. Attentive drivers focus on smooth logistics, contributing to a stress-free and memorable wedding day experience."
    },
    {
      "name": "Bus Hire for School Pune",
      "description": "Bus Hire for School Pune offers safe and reliable buses specifically tailored for school transportation needs, including daily pickups, field trips, and special events. These buses adhere to stringent safety norms, are regularly maintained, and driven by experienced drivers trained to handle student groups. Flexible scheduling ensures seamless coordination with school timings."
    },
    {
      "name": "Bus Hire for Outstation Pune",
      "description": "Bus Hire for Outstation Pune provides long-distance bus rentals ideal for group travel to nearby cities, tourist destinations, and business locations beyond Pune. The buses are designed for comfort and safety over extended journeys, featuring spacious seating, ample luggage space, and experienced drivers who ensure timely arrivals and smooth rides on intercity routes."
    },
    {
      "name": "Affordable Bus Hire Pune",
      "description": "Affordable Bus Hire Pune focuses on delivering cost-effective group transportation without sacrificing safety or quality. This service caters to budget-conscious customers such as schools, small businesses, and family groups, offering transparent pricing, well-maintained vehicles, and reliable drivers. It is a trusted option for economical and dependable travel within and outside Pune."
    },
    {
      "name": "Bus Hire in Hadapsar",
      "description": "Bus Hire in Hadapsar caters specifically to the Hadapsar locality, providing a fleet of well-maintained buses suitable for corporate events, family outings, and school trips. The service offers flexible booking options, timely pickups, and professional drivers familiar with the local traffic, ensuring safe and efficient transportation within Hadapsar and nearby areas."
    },
    {
      "name": "Bus Hire in Hinjewadi",
      "description": "Bus Hire in Hinjewadi specializes in transportation services for the IT and business hub of Pune. Catering to corporate clients, employee shuttles, and business tours, this service offers reliable buses with modern amenities, punctual drivers, and flexible rental packages designed to meet the demanding schedules of Hinjewadi’s dynamic workforce."
    },
    {
      "name": "Bus Hire in Pimpri",
      "description": "Bus Hire in Pimpri provides convenient and affordable bus rental options for the Pimpri region. Ideal for group travel, corporate events, and social outings, these buses are well-maintained and driven by skilled chauffeurs who prioritize safety and timely service. Flexible rental plans accommodate both short and long-term needs, ensuring a seamless travel experience."
    },
    {
      "name": "Bus Hire in Baner",
      "description": "Bus Hire in Baner offers dependable and punctual bus rental services tailored for the Baner locality. Suitable for family trips, corporate functions, and school transportation, this service focuses on vehicle cleanliness, professional drivers, and customized travel solutions to meet the diverse needs of Baner’s residential and business communities."
    },
    {
      "name": "Bus Hire near Me Pune",
      "description": "Bus Hire near Me Pune ensures quick and easy access to bus rental services close to your location. This service emphasizes fast response times, well-maintained vehicles, and professional drivers available for immediate or scheduled group travel across Pune. It simplifies the booking process and makes group transportation more convenient and accessible citywide."
    }
  ],
  "tableData": [
    ["Bus Hire in Pune", "Bus Rental Pune"],
    ["AC Bus Hire Pune", "Non AC Bus Hire Pune"],
    ["Luxury Bus Hire Pune", "Tourist Bus Hire Pune"],
    ["Mini Bus Hire Pune", "Volvo Bus Hire Pune"],
    ["Corporate Bus Hire Pune", "Wedding Bus Hire Pune"],
    ["Bus Hire for School Pune", "Bus Hire for Outstation Pune"],
    ["Affordable Bus Hire Pune", "Bus Hire in Hadapsar"],
    ["Bus Hire in Hinjewadi", "Bus Hire in Pimpri"],
    ["Bus Hire in Baner", "Bus Hire near Me Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers dependable and comfortable bus hire services in Pune, ideal for group travel, events, tours, and corporate transportation."
  },
  {
    "WhyChooseheading": "Wide Range of Bus Options",
    "WhyChoosedescription": "We provide buses in various seating capacities—from 17 to 53 seaters—to suit different group sizes and travel purposes."
  },
  {
    "WhyChooseheading": "Comfortable and Clean Buses",
    "WhyChoosedescription": "Our buses are well-maintained, regularly serviced, and sanitized to ensure passenger comfort and safety."
  },
  {
    "WhyChooseheading": "Clear and Competitive Pricing",
    "WhyChoosedescription": "Benefit from affordable and transparent pricing with no hidden costs or last-minute surprises."
  },
  {
    "WhyChooseheading": "Flexible Hire Durations",
    "WhyChoosedescription": "Hire buses on an hourly, daily, or multi-day basis as per your travel schedule and needs."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Every Trip",
    "WhyChoosedescription": "Our professional drivers are courteous, punctual, and trained to provide a smooth and secure travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning, and customer queries."
  },
  {
    "WhyChooseheading": "Quick and Easy Booking Process",
    "WhyChoosedescription": "Hire a bus with just a few clicks or a call, with prompt vehicle dispatch and service across Pune."
  }
]



























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer bus hire services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides reliable and affordable bus hire services in Pune for various group travel needs.',
  },
  {
    question: 'How can I hire a bus in Pune with Amruta Travels?',
    answer: 'You can hire a bus easily through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What types of buses are available for hire in Pune?',
    answer: 'We offer a variety of buses including mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses to meet your specific needs.',
  },
  {
    question: 'Are the drivers experienced and trained for bus hire in Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and skilled in safely driving buses of different sizes in Pune.',
  },
  {
    question: 'Can buses be hired for weddings, corporate events, tours, and airport transfers in Pune?',
    answer: 'Certainly. Our buses are suitable for weddings, corporate events, sightseeing tours, airport transfers, and other group travel requirements.',
  },
  {
    question: 'Is the bus hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 bus hire services in Pune to fit your schedule and travel plans.',
  },
  {
    question: 'What safety and hygiene protocols are followed for bus hires?',
    answer: 'All vehicles are sanitized before every trip, and our drivers adhere to strict hygiene and safety measures.',
  },
  {
    question: 'What payment methods are accepted for bus hire in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during the bus hire period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your bus hire period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kiran More',
    feedback: 'Hiring a bus from Amruta Travels Pune was seamless. The vehicle was comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah',
    feedback: 'Excellent bus hire service with Amruta Travels. They made our corporate trip in Pune very smooth and hassle-free.',
    rating: 5,
  },
];

































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/13.jpg",
  "description": "Hire buses in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, Luxury, Mini, and Volvo buses for corporate events, weddings, school trips, and outstation travel. Affordable and reliable bus hire services in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "17800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/bus-hire-in-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>Bus Hire in Pune | AC, Luxury & Mini Bus Rental | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Hire buses in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, Luxury, Mini, and Volvo buses for corporate, wedding, school, and outstation trips. Affordable and trusted bus hire service in Pune."
  />
  <meta
    name="keywords"
    content="Bus Hire in Pune, Bus Rental Pune, AC Bus Hire Pune, Non AC Bus Hire Pune, Luxury Bus Hire Pune, Tourist Bus Hire Pune, Mini Bus Hire Pune, Volvo Bus Hire Pune, Corporate Bus Hire Pune, Wedding Bus Hire Pune, Bus Hire for School Pune, Bus Hire for Outstation Pune, Affordable Bus Hire Pune, Bus Hire in Hadapsar, Bus Hire in Hinjewadi, Bus Hire in Pimpri, Bus Hire in Baner, Bus Hire near Me Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinpune;